import { directusService } from '@/services/api.service';

export const getAllAvailableModelData = async (filters = {}, sort = 'year') => {
  const { data } = await directusService.get('/items/model', {
    params: {
      filter: filters,
      sort: sort,
      limit: '-1',
    },
  });

  return data as any[];
};
